import { DiscountValueType } from "@redotech/redo-discounts-common/discount";
import { RedoTextInput } from "../../../arbiter-components/input/redo-text-input";
import { RedoRadioGroup } from "../../../arbiter-components/radio/redo-radio-group";
import { RedoSingleSelectDropdownInput } from "../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "../../../flex";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";
import { ProductSelection } from "../../discount-shared";
import { discountValueTypeItems } from "../constants";
import { CollectionsPicker, ProductsPicker } from "../pickers";

export function CustomerGetsField({
  itemType,
  setItemType,
  products,
  setProducts,
  collections,
  setCollections,
  quantity,
  setQuantity,
  discountValue,
  setDiscountValue,
  discountType,
  setDiscountType,
}: {
  itemType: "products" | "collections";
  setItemType: (value: "products" | "collections") => void;
  products: ProductSelection[];
  setProducts: (products: ProductSelection[]) => void;
  collections: string[];
  setCollections: (collections: string[]) => void;
  quantity: number;
  setQuantity: (value: number) => void;
  discountValue: number;
  setDiscountValue: (value: number) => void;
  discountType: DiscountValueType;
  setDiscountType: (value: DiscountValueType) => void;
}) {
  return (
    <LabeledInput
      label={
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Customer gets
        </Text>
      }
      size={LabelSize.EXTRA_SMALL}
    >
      <Flex dir="column" gap="md">
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            From
          </Text>
          <RedoRadioGroup
            options={[
              { id: "products", label: "Specific products" },
              { id: "collections", label: "Collections" },
            ]}
            setValue={(value) =>
              setItemType(value as "products" | "collections")
            }
            value={itemType}
          />
          {itemType === "products" && (
            <ProductsPicker products={products} setProducts={setProducts} />
          )}
          {itemType === "collections" && (
            <CollectionsPicker
              collections={collections}
              setCollections={setCollections}
            />
          )}
        </Flex>
        <RedoTextInput
          inputTypeHint="number"
          label="Quantity"
          placeholder="1"
          setValue={(value) => {
            setQuantity(value ? Number(value) : 1);
          }}
          value={quantity?.toString() || "1"}
        />
        <Flex align="center" gap="md">
          <RedoTextInput
            inputTypeHint="number"
            label="Discount"
            placeholder="100"
            setValue={(value) => {
              setDiscountValue(value ? Number(value) : 100);
            }}
            value={discountValue?.toString() || "100"}
          />
          <RedoSingleSelectDropdownInput<DiscountValueType>
            label="Type"
            options={discountValueTypeItems}
            optionSelected={({ item }) => {
              setDiscountType(item.value);
            }}
            selectedItem={discountValueTypeItems.find(
              (o) => o.value === discountType,
            )}
            size="xs"
          />
        </Flex>
      </Flex>
    </LabeledInput>
  );
}
